import { render, staticRenderFns } from "./ListPurchasesInvoicePage.vue?vue&type=template&id=7f94c644"
import script from "./ListPurchasesInvoicePage.vue?vue&type=script&lang=js"
export * from "./ListPurchasesInvoicePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports